
export interface WeddingBudgetBenefitsContentProps {
    h1: string;
    para1: string;
    benifitsData: {
        heading: string;
        paragraphs: string[];
    }[];
}

export const weddingBudgetBenefitsContent = {
    h1: "Benefits of using a wedding budget template",
    para1: "A wedding budget template is a valuable tool that can significantly enhance your wedding planning experience. It offers numerous benefits that help couples stay organized, reduce stress, and effectively manage their wedding expenses.", 
    benifitsData : [
    {
        heading: "Staying organized",
        paragraphs: [
            "A wedding budget template centralizes all financial information, making it easily accessible for planning and reference. This simplifies the management of financial details, ensuring organization throughout the wedding planning process.",
            "This level of organization contributes to a stress-free wedding planning experience, allowing you to stay organized and focus on the joyous aspects of your big day during the wedding week.",
        ]
    },
    {
        heading: "Reducing wedding stress",
        paragraphs: [
            "A structured budget template provides spending clarity, helping to alleviate anxiety for couples. Clear budget guidelines can significantly reduce the stress associated with wedding planning.By outlining financial expectations, a wedding budget template helps in managing stress and ensuring a more enjoyable planning process."
        ]
    },
    {
        heading: "Effective wedding expense tracking",
        paragraphs: [
            "Tracking wedding expenses is crucial to avoid overspending and ensure financial responsibility during wedding planning. Keeping track of wedding vendor payments ensures timely paid payments and helps prevent overspending.",
            "Maintaining flexibility in your wedding budget allows it to evolve and adapt, which is key to managing unexpected expenses effectively."
        ]
    },
]}